import { render, staticRenderFns } from "./preview-intro.vue?vue&type=template&id=3b13f562&scoped=true&"
import script from "./preview-intro.vue?vue&type=script&lang=js&"
export * from "./preview-intro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13f562",
  null
  
)

export default component.exports